import React from "react";
import styled from "styled-components";
import { QRCodeCanvas } from 'qrcode.react';
import { jsPDF } from "jspdf";
import { Input } from "../shared/Input";
import { MenuCard } from "../menu/MenuCard";
import { observer } from "mobx-react-lite";
import { managementStore } from "../../stores/ManagementStore";
import { ModulesOfWorkshopListView } from "./ManagementListView";
import { Trans, useTranslation } from "react-i18next";
import { ModulesToPlayListView } from "./ModuleToPlayListView";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { ListItem } from "../menu/ListItem";
import { undoableManagementToggleItemViewOpen } from "../../stores/undo/operation/ManagementToggleItemViewOpenOp";
import { RiDeleteBack2Line } from "react-icons/ri";
import { AccessCode } from "./AccessCode";
import { userStore } from "../../stores/UserStore";
import { workshopAdminAccessCodeConfig, workshopPlayCodeConfig } from "../../../shared/helper/accesscodeHelpers";
const PropertyView = styled(MenuCard).withConfig({
  displayName: "WorkshopDetailView__PropertyView",
  componentId: "sc-ds1tco-0"
})(["grid-column-start:2;pointer-events:all;"]);
const PropertyContainer = styled.table.withConfig({
  displayName: "WorkshopDetailView__PropertyContainer",
  componentId: "sc-ds1tco-1"
})(["background:white;padding:3px;margin:3px;th{font-weight:normal;vertical-align:top;padding:5px 0px;}"]);
const ContentListItem = styled(ListItem).withConfig({
  displayName: "WorkshopDetailView__ContentListItem",
  componentId: "sc-ds1tco-2"
})([":hover{cursor:default;}"]);
const ListItemHeader = styled.div.withConfig({
  displayName: "WorkshopDetailView__ListItemHeader",
  componentId: "sc-ds1tco-3"
})(["display:contents;:hover{cursor:pointer;}"]);
export const WorkshopDetailView = observer(props => {
  const {
    t
  } = useTranslation();
  const selectedWorkshop = managementStore.getWorkshop(props.editItem);
  const modulesToPlayOpenString = selectedWorkshop.$modelId + "-modulesToPlay";
  const defaultServerUrl = window.location.origin;
  const currentServerUrl = selectedWorkshop.serverUrl || defaultServerUrl;

  const generatePDF = () => {
    const doc = new jsPDF();
    const brandImageSrc = "assets/branding/ADAMARA_harshwaters_A.png";
    const font = doc.getFont();
    const infoFontSize = 14;
    const blockTitleFontSize = 18;
    const blockValueFontSize = 22;

    const generatePDFHeader = () => {
      const qrCodeCanvas = document.querySelector('.qrCode > canvas');
      doc.addImage(brandImageSrc, "PNG", 57, 20, 100, 56.3);
      doc.addImage(qrCodeCanvas, "JPEG", 82.5, 90, 45, 45);
      generateInfoBlock("URL", currentServerUrl, 150);
    };

    const generateInstructions = () => {
      doc.setFontSize(infoFontSize);
      doc.text([t("management.pdf_instructions_1"), t("management.pdf_instructions_2")], 105, 250, {
        align: "center"
      });
    };

    const generateInfoBlock = (blockName, blockValue, yPos) => {
      doc.setFontSize(blockTitleFontSize);
      doc.text(blockName, 105, yPos, {
        align: "center"
      });
      doc.setFont(font.fontName, "bold");
      doc.setFontSize(blockValueFontSize);
      doc.text(blockValue, 105, yPos + 10, {
        align: "center"
      });
      doc.setFont(font.fontName, "normal");
    };

    doc.setProperties({
      title: "Workshop Print Sheet"
    });
    generatePDFHeader();
    generateInfoBlock(t("management.workshop_play_code"), selectedWorkshop.playcode, 180);
    generateInstructions();
    selectedWorkshop.modules.map(moduleId => {
      const module = managementStore.getModule(moduleId);
      if (!module) return;
      doc.addPage();
      generatePDFHeader();
      generateInfoBlock(t("management.module_name"), module.name, 180);
      generateInfoBlock(t("management.module_access_code"), module.accesscode, 210);
      generateInstructions();
    });
    window.open(doc.output("bloburl").toString());
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, selectedWorkshop && /*#__PURE__*/React.createElement(PropertyView, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "none"
    },
    className: "qrCode"
  }, /*#__PURE__*/React.createElement(QRCodeCanvas, {
    value: currentServerUrl
  })), /*#__PURE__*/React.createElement(PropertyContainer, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t("management.workshop_name")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Input, {
    value: selectedWorkshop.name,
    onChange: ({
      target
    }) => selectedWorkshop.setName(target.value)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t("management.workshop_play_code")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AccessCode, {
    value: selectedWorkshop.playcode,
    setValue: selectedWorkshop.setPlaycode.bind(selectedWorkshop),
    config: workshopPlayCodeConfig
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t("management.workshop_access_code")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AccessCode, {
    value: selectedWorkshop.accesscode,
    setValue: selectedWorkshop.setAccesscode.bind(selectedWorkshop),
    config: workshopAdminAccessCodeConfig
  }), userStore.mayEditAllWorkshops && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey:
    /*t*/
    "management.workshop_access_code_should_be_removed_after_workshop"
  }, "0", /*#__PURE__*/React.createElement(RiDeleteBack2Line, null), "2")))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t("management.pdf_server_url")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Input, {
    value: selectedWorkshop.serverUrl,
    placeholder: defaultServerUrl,
    onChange: ({
      target
    }) => selectedWorkshop.setServerUrl(target.value)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => generatePDF()
  }, t("management.print_pdf")))))), /*#__PURE__*/React.createElement(ContentListItem, null, /*#__PURE__*/React.createElement(ListItemHeader, {
    onClick: () => undoableManagementToggleItemViewOpen(modulesToPlayOpenString)
  }, managementStore.isDetailViewOpen(modulesToPlayOpenString) ? /*#__PURE__*/React.createElement(IoMdArrowDropdown, null) : /*#__PURE__*/React.createElement(IoMdArrowDropright, null), t("management.modules_to_play"), ":"), selectedWorkshop && managementStore.isDetailViewOpen(modulesToPlayOpenString) && /*#__PURE__*/React.createElement(ModulesToPlayListView, {
    playableModules: managementStore.getAllPlayableModules,
    modulesToPlay: selectedWorkshop === null || selectedWorkshop === void 0 ? void 0 : selectedWorkshop.modulesToPlay,
    addModuleToPlay: selectedWorkshop.addModuleToPlay.bind(selectedWorkshop),
    removeModuleToPlay: selectedWorkshop.removeModuleToPlay.bind(selectedWorkshop),
    showFilter: true
  })), /*#__PURE__*/React.createElement(ContentListItem, null, /*#__PURE__*/React.createElement("div", null, t("management.modules"), ":"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModulesOfWorkshopListView, {
    workshopId: selectedWorkshop === null || selectedWorkshop === void 0 ? void 0 : selectedWorkshop.$modelId
  })))));
});